import React from "react";
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import DefaultImage from "../../../Icons/defaultImage.svg";

export interface Props {
  getValue: any;
  row: any;
  image?: string;
  [key: string]: any;
}

const ImageCell: React.FC<Props> = (props) => {
  const { getValue, row, image = "preview_image" } = props;
  const imageUrl = row.original?.[image];
  return (
    <div className={tw`flex items-center gap-x-2`}>
      {imageUrl ? (
        <img
          src={imageUrl}
          className={tw`w-[30px] h-[30px] object-cover mr-[8px]`}
          alt=""
        />
      ) : (
        <img
          src={DefaultImage}
          className={tw`w-[30px] h-[30px] bg-transparent`}
          alt=""
        />
      )}
      {getValue()}
    </div>
  );
};

export default ImageCell;
